import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAsyncEffect } from "../components/common/hooks/index.js";
import { FeatureActionCreators } from "../redux/action-creators/index.js";
import { UserContextSelectors } from "../redux/selectors/index.js";
import { PageContextUtils, ExternalUtils } from "../utils/index.js";

export const useFeatureStore = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);

  const dispatch = useDispatch();

  useAsyncEffect(
    async () => {
      const abTestActiveFeatures =
        await ExternalUtils.UCSDKService.getActiveAbTestFeaturesAsync();

      dispatch(
        FeatureActionCreators.setABTestActiveFeatures(abTestActiveFeatures)
      );
    },
    async () => Promise.resolve(),
    [isAuthenticated]
  );

  useEffect(() => {
    const { features, featuresFlag } = PageContextUtils.getFeaturesData();

    dispatch(
      FeatureActionCreators.setActiveFeatures(
        // this list contains features that are either active or should be AB tested
        features.filter(
          feature =>
            feature.value.toLowerCase() === "on" ||
            feature.value.toLowerCase() === "ab"
        )
      )
    );

    dispatch(
      FeatureActionCreators.setActiveFeatureFlags(
        featuresFlag?.filter(
          featureFlag => featureFlag.value.toLowerCase() === "on"
        ) || []
      )
    );
  }, [dispatch]);
};
